import { useEffect } from "react";
import LegalPage, { type LegalSection } from "@/components/feature/LegalPage";

const SECTIONS: LegalSection[] = [
  {
    heading: "Information we collect",
    body: [
      "We collect the information you give us directly, such as your name, email address, business name and payment details when you create an account or contact us.",
      "When you use Joble, we also collect information about how your agents are configured and how visitors interact with them, including chat transcripts, call recordings and booking details. This data is used to provide and improve the service.",
    ],
  },
  {
    heading: "How we use your information",
    body: [
      "We use your information to set up and run your account, to power your Web and Phone Agents, to process payments, and to provide customer support.",
      "We may also use it to send you service updates and, where you have agreed, product news. You can opt out of marketing messages at any time.",
    ],
  },
  {
    heading: "Cookies and analytics",
    body: [
      "We use cookies and similar technologies to keep you signed in, remember your preferences and understand how the product is used so we can make it better.",
      "You can control cookies through your browser settings, though some parts of Joble may not work correctly without them.",
    ],
  },
  {
    heading: "Sharing your information",
    body: [
      "We do not sell your personal information. We share it only with trusted service providers who help us operate Joble, such as hosting, payments and communications partners, and only to the extent needed to deliver the service.",
      "We may disclose information where we are legally required to do so, or to protect the rights, property and safety of Joble, our customers and the public.",
    ],
  },
  {
    heading: "Data retention and security",
    body: [
      "We keep your information for as long as your account is active or as needed to provide the service, comply with our legal obligations and resolve disputes.",
      "We use industry-standard safeguards, including encryption in transit and at rest, to protect your data. No system is completely secure, so we encourage you to use a strong, unique password.",
    ],
  },
  {
    heading: "Your rights",
    body: [
      "Depending on where you live, you may have the right to access, correct, export or delete the personal information we hold about you, and to object to certain processing.",
      "To exercise any of these rights, contact us at support@joble.app and we will respond within the timeframes required by applicable law.",
    ],
  },
  {
    heading: "Changes to this policy",
    body: [
      "We may update this policy from time to time. When we make material changes we will notify you by email or through the product, and update the date at the top of this page.",
    ],
  },
];

export default function PrivacyPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Privacy Policy | Joble";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <LegalPage
      eyebrow="Privacy Policy"
      title="Your data, handled with care"
      updated="Last updated: 6 October 2026"
      intro="This policy explains what information Joble collects, how we use it, and the choices you have. We keep it plain and readable, because you should be able to understand exactly what happens to your data."
      sections={SECTIONS}
    />
  );
}